import { useMemo } from 'react';
import { useOgTenantInfo } from '@atlassian/jira-eoc-tenant-info';
import { useIsAdmin, useIsSiteAdmin } from '@atlassian/jira-tenant-context-controller';
import { useOgConsolidationUserState } from '../use-og-consolidation-user-state';

export const useChangeboardingBroadcastWidget = () => {
	const { data, error } = useOgConsolidationUserState();
	const isAdmin = useIsAdmin();
	const isSiteAdmin = useIsSiteAdmin();
	const { isTransitionEligible, error: tenantInfoError } = useOgTenantInfo();

	const isEnabled = Boolean(
		(isAdmin || isSiteAdmin) &&
			// Tenant info
			!tenantInfoError &&
			isTransitionEligible &&
			// User state
			!error &&
			data &&
			!data.isBroadcastWidgetDismissed,
	);

	return useMemo(
		() => ({
			isEnabled,
		}),
		[isEnabled],
	);
};
